'use client'
import { usePathname } from 'next/navigation'
import React, { useEffect } from 'react'
import { REACT_APP_ENV } from '../constants'
import { useAds } from '../revive-ads/ads-context'

interface GoogleAdsProps {
  slotId: string
  dimension: any
  addId: string
  divId: string
  className?: string
  isTest?: boolean
  [key: string]: any
}

declare global {
  interface Window {
    googletag: any
  }
}

const GoogleAds: React.FC<GoogleAdsProps> = ({
  slotId,
  dimension,
  addId,
  divId,
  className,
  ...rest
}) => {
  const { isAdsActive } = useAds()
  const pathname = usePathname()

  useEffect(() => {
    // Check if ads are active
    if (!isAdsActive) return

    let ads: any
    let googleTag = window.googletag || { cmd: [] }
    if (googleTag) {
      const initGoogleAds = () => {
        googleTag = window.googletag || { cmd: [] }
        googleTag?.cmd?.push(() => {
          ads = googleTag
            .defineSlot(`/${slotId}/${addId}`, [dimension], divId)
            .addService(googleTag.pubads())
          googleTag.pubads().enableSingleRequest()
          googleTag.enableServices()
          googleTag.display(divId)
        })
      }

      if (window.isAddLoaded) initGoogleAds()
      else {
        window.addEventListener('adLoadEvent', initGoogleAds)
      }

      return () => {
        ads && googleTag?.destroySlots([ads])
      }
    }
  }, [pathname, slotId, addId, dimension, divId, isAdsActive])

  if (REACT_APP_ENV === 'development' || !isAdsActive) return null

  return (
    <div className={`${className || ''} w-full flex justify-center`} {...rest}>
      <div id={divId} style={{ width: dimension[0] }}></div>
    </div>
  )
}

export default GoogleAds
